import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import client from '@/utilities/client.js';

Vue.use(Vuex);

const defaultState = {
  token: '',
  axiosLoading: false,
  startAt: '',
  routeType: '',
  box: {},
  maintenance: {},
  items: {},
  quantities: {},
  startCheck: {},
  finalCheck: {},
  routes: {},
  maintenanceList: {},
};

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: Object.assign({}, defaultState),
  actions: {
    clearStore: (context) => {
      context.commit('clearStore');
    },
    changeAxiosLoadingStatus: (context, data) => {
      context.commit('changeAxiosLoadingStatus', data);
      return true;
    },
    signIn: (context, data) => new Promise((resolve, reject) => {
      client.post('/token.json', { maintenanceHandyUserId: data.maintenanceHandyUserId })
        .then((response) => {
          context.commit('setMaintenanceHandyUser', response.data.data);
          resolve();
        })
        .catch((e) => {
          reject(e.response);
        });
    }),
    getMaintenanceData: (context, data) => new Promise((resolve, reject) => {
      client.get(`/maintenance_data/${data.boxId}.json`)
        .then((response) => {
          context.commit('setMaintenanceData', response.data.data);
          resolve();
        })
        .catch((e) => {
          reject(e.response);
        });
    }),
    getMaintenanceList: context => new Promise((resolve, reject) => {
      context.commit('clearMaintenanceData');
      client.get('/maintenance_list')
        .then((response) => {
          context.commit('setMaintenanceList', response.data.data);
          resolve();
        })
        .catch((e) => {
          reject(e.response);
        });
    }),
    setCheckAnswer: (context, data) => {
      context.commit('setCheckAnswer', data);
      return true;
    },
    setQuantity: (context, data) => {
      context.commit('setQuantity', data);
      return true;
    },
    setRoutes: (context, data) => {
      context.commit('setRoutes', data);
    },
    setComment: (context, data) => {
      context.commit('setComment', data);
      return true;
    },
    saveMaintenanceData: context => new Promise((resolve, reject) => {
      client.post('/maintenance_data', context.state)
        .then(() => {
          context.commit('clearMaintenanceData');
          resolve();
        })
        .catch((e) => {
          reject(e.response);
        });
    }),
    updateCheckStatus: (context, data) => new Promise((resolve, reject) => {
      client.post('/update_check_status', data)
        .then((response) => {
          context.commit('setMaintenanceList', response.data.data);
          resolve();
        })
        .catch((e) => {
          reject(e.response);
        });
    }),
    updateWorkerComment: context => new Promise((resolve, reject) => {
      client.post('/update_worker_comment', context.state.maintenance)
        .then((response) => {
          context.commit('clearMaintenanceData');
          context.commit('setMaintenanceList', response.data.data);
          resolve();
        })
        .catch((e) => {
          reject(e.response);
        });
    }),
  },
  mutations: {
    clearStore: (state) => {
      Object.assign(state, defaultState);
    },
    changeAxiosLoadingStatus: (state, data) => {
      state.axiosLoading = data.status;
    },
    setMaintenanceHandyUser: (state, data) => {
      state.token = data.token;
    },
    setMaintenanceData: (state, data) => {
      Object.keys(state).forEach((key) => {
        if (data[key]) {
          state[key] = data[key];
        }
      });
      return true;
    },
    setMaintenanceList: (state, data) => {
      state.maintenanceList = data.maintenanceList;
      return true;
    },
    setCheckAnswer: (state, data) => {
      state[data.type].answers[data.key] = data.answer;
      return true;
    },
    setQuantity: (state, data) => {
      state.quantities[data.type][data.itemId] = data.quantity;
      return true;
    },
    setRoutes: (state, data) => {
      state.routeType = data.routeType;
      return true;
    },
    setComment: (state, data) => {
      state.maintenance.workerComment = data.comment;
      return true;
    },
    clearMaintenanceData: (state) => {
      const data = Object.assign({}, defaultState);
      data.token = state.token;
      Object.assign(state, data);
      return true;
    },
  },
  getters: {
    boxPlaceName: (state) => {
      const name = [state.box.companyName, state.box.shortPlaceName].filter(v => v).join(' ');
      return [state.box.encryptBoxId, name, state.box.floorName].filter(v => v).join(' / ');
    },
    recallDate: state => state.box.recallDate,
    maintenanceId: state => state.maintenance.maintenanceId,
    maintenanceType: state => state.maintenance.maintenanceType,
    transferInformation: state => state.box.transferInformation,
    comment: state => state.box.comment,
    workerComment: state => state.maintenance.workerComment,
    items: state => conditionType => state.items[conditionType],
    quantities: state => state.quantities,
    lastDeliveryQuantities: state => state.quantities.lastDelivery,
    stockQuantities: state => state.quantities.stock,
    lossQuantities: state => state.quantities.loss,
    prepareQuantities: state => state.quantities.prepare,
    takeoutQuantities: state => state.quantities.takeout,
    recallQuantities: state => state.quantities.recall,
    quantityList: state => (itemId) => {
      const lastDelivery = state.quantities.lastDelivery[itemId];
      const stock = state.quantities.stock[itemId] === '' ? 0 : state.quantities.stock[itemId];
      const loss = state.quantities.loss[itemId];
      const recall = state.quantities.recall[itemId] === '' ? 0 : state.quantities.recall[itemId];
      const prepare = state.quantities.prepare[itemId];
      const takeout = state.quantities.takeout[itemId];
      const actualDelivery = prepare - takeout;
      const deliveryResult = (stock - loss - recall) + actualDelivery;
      const sales = lastDelivery - stock;

      return {
        lastDelivery,
        stock,
        loss,
        recall,
        prepare,
        takeout,
        actualDelivery,
        deliveryResult,
        sales,
      };
    },
    startCheck: state => state.startCheck,
    finalCheck: state => state.finalCheck,
    routeType: state => state.routeType,
    routes: state => state.routes[state.routeType],
    token: state => state.token,
    axiosLoading: state => state.axiosLoading,
    maintenanceList: state => state.maintenanceList,
  },
  modules: {

  },
});



// WEBPACK FOOTER //
// ./src/models/store.js